import React, { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function FormGrid({
  cols = 5,
  className,
  children,
}: {
  cols?: number;
  className?: string;
  children: ReactNode;
}) {
  if (Array.isArray(children) && (children.length === 0 || children.every(item => !item))) { return null; }
  return (
    <div
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 gap-3 content-center w-full",
        `md:grid-cols-${cols}`,
        className,
      )}
    >
      {children}
    </div>
  );
}

export function FormGroup({
  label,
  className,
  children,
}: {
  label?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {label && (
        <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">
          {label}
        </h3>
      )}
      {children}
    </div>
  );
}

export function FormActions({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 place-content-between gap-2 col-span-1 sm:col-span-2 md:col-span-4 w-full",
        className,
      )}
    >
      <div className="flex flex-row justify-end gap-4">{children}</div>
    </div>
  );
}
